/** Centralized dashboard configuration driven by environment variables. */

export const config = {
  /** When true, pages use mock fixtures instead of live API/WebSocket data. */
  useMocks: import.meta.env.VITE_USE_MOCKS === 'true',

  /** Base URL for the REST API (Vite proxies /api to the Rust backend). */
  apiBaseUrl: import.meta.env.VITE_API_URL || '/api',

  /** WebSocket endpoint path (Vite proxies /ws to the Rust backend). */
  wsUrl: import.meta.env.VITE_WS_URL || '/ws',
}
